





















































import Vue from 'vue'

import BaseHeader from '../components/Base/Header.vue'
import BaseButton from '../components/Base/Button.vue'
import BaseSelectWrap from '../components/Base/SelectWrap.vue'
import EditorImageWrap from '../components/Editor/ImageWrap.vue'
import EditorModal from '../components/Editor/Modal.vue'
import ControllerNavigation from '../components/Controller/Navigation.vue'

import Range from '../utils/Range'

import {Shape, Current} from '../interface'
import types from '../store/types'

export default Vue.extend({
  components: {
    BaseHeader,
    BaseButton,
    BaseSelectWrap,
    EditorImageWrap,
    EditorModal,
    ControllerNavigation
  },

  // $refs: {
  //   explainModal: EditorModal
  // },

  data() {
    return {
      isViewNumber: false,
    }
  },

  computed: {
    currentFile(): FileReader | null {
      return this.$store.state.Current.file
    },
    haveList(): boolean {
      return this.$store.state.BadgeList.list.length > 0
    },
    currentNumber: {
      get(): number {
        return this.$store.state.Current.number
      },
      set(num: number): void {
        this.$store.commit(types.mutations.CURRENT_NUMBER, num)
      }
    },
    numbers() {
      const shapeList: Shape[] = this.$store.state.Shape.list
      const selectedShape = (this.$store.state.Current as Current).shape
      const shapeInfo = shapeList[selectedShape]
      if (!shapeInfo) {
        return Range(10, 5000, 10)
      }

      const quantityLimit = shapeInfo.quantityLimit

      if (quantityLimit > 10) {
        return Range(10, quantityLimit, 10)
      } else if (quantityLimit === 1) {
        return [1]
      } else {
        return Range(1, quantityLimit, 1)
      }
    }
  },

  beforeCreate() {
    if (this.$store.state.Current.file === null) {
      this.$router.push('/')
      return
    }
  },

  methods: {
    editCancel(): void {
      if (window.confirm('修正内容を取り消しますか？')) {
        this.$router.push('/list')
      }
    },
    viewNumberModal(): void {
      this.isViewNumber = true
    },
    hideNumberModal(): void {
      this.isViewNumber = false
    },
    applyBadge(): void {
      if (this.currentNumber <= 0) {
        window.alert('注文数をご選択ください')
        return
      }

      if (this.$store.state.BadgeList.selected < 0) {
        this.$store.commit(types.mutations.BADGE_LIST_ADD, this.$store.state.Current)
      } else {
        this.$store.commit(types.mutations.BADGE_LIST_UPDATE, this.$store.state.Current)
      }
      this.$router.push('/list')
    },

    viewExplainModal(): void {
      (this.$refs.explainModal as any).showModal()
    }
  }
})
